/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */

import { IResourceProps } from 'apmui/resource/ResourceLoader';
import { RESOURCE } from 'apmui/resource/ResourceType';
import { WebtopResourceModel } from 'apmui/resource/WebtopResourceModel';

class WebSshModel extends WebtopResourceModel {
    // static
    static readonly propNames = ['application_uri', 'publish_on_webtop', ...WebtopResourceModel.propNames];

    // instance
    type: RESOURCE.WEBSSH = RESOURCE.WEBSSH;
    applicationUri: string;
    hidden: boolean;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);
        this.applicationUri = resource.props.application_uri;
        this.hidden = resource.props.publish_on_webtop === '0';
        this.undefinedIconToDefault();
    }

    getPropNames(): string[] {
        return WebSshModel.propNames;
    }

    launchResource() {
        window.open(this.applicationUri, '_blank', '');
    }
}

export { WebSshModel as default, WebSshModel };
